import { render, staticRenderFns } from "./CampaignSettingsSubpage.vue?vue&type=template&id=7b8d5428&"
import script from "./CampaignSettingsSubpage.vue?vue&type=script&lang=js&"
export * from "./CampaignSettingsSubpage.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSettingsSubpage.vue?vue&type=style&index=0&id=7b8d5428&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports